export default __webpack_public_path__ + "static/media/ThreeDotsIcon.6d518c4b.svg";